__turbopack_context__.v({
  "checkboxBox": "Checkbox-module__gTZQKa__checkboxBox",
  "checkboxField": "Checkbox-module__gTZQKa__checkboxField",
  "checkboxIcon": "Checkbox-module__gTZQKa__checkboxIcon",
  "checked": "Checkbox-module__gTZQKa__checked",
  "disabled": "Checkbox-module__gTZQKa__disabled",
  "error": "Checkbox-module__gTZQKa__error",
  "hiddenInput": "Checkbox-module__gTZQKa__hiddenInput",
  "indeterminate": "Checkbox-module__gTZQKa__indeterminate",
  "label": "Checkbox-module__gTZQKa__label",
  "labelAddition": "Checkbox-module__gTZQKa__labelAddition",
  "labelExpanded": "Checkbox-module__gTZQKa__labelExpanded",
  "showMore": "Checkbox-module__gTZQKa__showMore",
});
